import React, { useState, ChangeEvent } from "react";
import {
  Container,
  Grid,
  TextField,
  Button,
  Typography,
  Paper,
  FormControl,
  FormControlLabel,
  Checkbox,
  Select,
  MenuItem,
  InputLabel,
  Card,
  CardContent,
  Box,
} from "@mui/material";

const contactUsImage = require("../assets/images/contactUs.png");

const stateOptions: Record<string, string> = {
  AK: "0e9dea26-2344-4913-a42e-c249087c43ab",
  AR: "d7c0d8c1-d398-4e59-b1d9-25c3431aa5ed",
  AZ: "fd65a49b-6d27-4ce4-b235-52711297695d",
  CA: "bc106e8e-57d4-4f03-af4b-6d13b1ae5ff2",
  CO: "b0f7c842-6c68-447c-ad82-ccdd206d4611",
  CT: "bf0ad125-93e5-4102-b338-b06cccd8b165",
  DE: "bcf441e8-d3ab-4ba3-b6fc-d85289c344d8",
  FL: "bbec6df7-68f9-4422-8fd4-df8548b3e1ba",
  GA: "4dcfd164-2991-49e3-99f1-26b876122bdd",
  HI: "ef21f617-9c27-4d74-8a5b-81b219dce1d9",
  IA: "36a55195-7ce3-45ef-b7b3-a529230a358f",
  ID: "49108ff8-11e6-44c8-b219-18a3bf3f5442",
  IL: "73077e2f-f664-400e-b77b-73f27ba32e57",
  IN: "9ba50cd6-ec43-49b3-915a-1a1b5af031c9",
  KS: "81e7ee06-6c9f-448f-917b-fd6dba5bcccf",
  KY: "82254524-e9b4-4dc8-8565-91a62e094cd1",
  LA: "f46fc489-3534-4e3a-a671-6c9bdcb019b7",
  MA: "e689868f-6af2-4261-9b8a-05b59afc69f2",
  MD: "2a061177-dc73-40b3-af63-d35ba8e0ae99",
  ME: "dad683c7-86ae-4ad2-9fd2-abb2d8d7ab47",
  MI: "a9354270-d44b-4c5b-8bea-4c48ea458c63",
  MN: "14a2ac6e-ba34-4faf-a659-34db046f8640",
  MO: "32d7783b-e179-4b22-87c8-5198d615f32f",
  MS: "6aab015f-43a8-4dd6-9948-09c6b646daad",
  MT: "60986d37-b178-4ab3-9800-28865f235662",
  NC: "d6809cf9-9675-432d-95c4-99830fe32098",
  ND: "c4f5eda6-1655-4484-92fd-d27688e02cee",
  NE: "08105167-1e0c-498e-bf0d-bf46e2442970",
  NH: "28a4c5f6-448d-4056-9256-b6393240782d",
  NJ: "4f9b756c-c516-4797-a848-297fdcaa9035",
  NM: "8b93d203-2cc2-4d88-8c9b-5b6a0f722e13",
  NV: "ddd23780-d277-4315-9d95-46c68f04a47d",
  NY: "aa74cfba-2ab0-4a95-8804-bc2eec5405a4",
  OH: "33f44a59-f3e7-413f-bd43-3264ee481c09",
  OK: "2f7a9535-7dbf-4d32-a7ed-169f40bede6e",
  OR: "b62e4434-78c9-47a9-b5fd-fc3af4b917d9",
  PA: "2215ab14-3023-4bed-a5ae-1bcb8d079160",
  RI: "a5918580-59e0-4695-8be6-511c3c2e24df",
  SC: "7e43ae07-758f-4ba5-b0f3-551ae9cdb703",
  SD: "6722abfd-f0dc-4725-958e-de6e982f7dfc",
  TN: "7d58d544-73c2-4e26-acc4-dae4e09b95c0",
  TX: "afd37db6-feea-448e-b2cf-39f8215e94e8",
  UT: "4abcb058-93c0-4e2e-b385-11913020ef98",
  VT: "d5f9a051-85e1-4c88-aab8-33b25151d25d",
  VA: "e4e53059-b9d0-4a82-a59b-003dc3a9bda8",
  WA: "2584baca-36f0-4637-8696-f506941dcf1d",
  WV: "4803f484-331f-4f36-8b9b-b0c888b26612",
  WI: "e907afd5-2baa-4748-bf91-afcab8e43368",
  WY: "400778e1-e633-424f-b1b1-bb2b6f7a4ce2"
};

const storeTypeOptions: Record<string, string> = {
  "Kids": "734f1462-eb4e-4066-bd16-49ac9cdeac9b",
  "Women's Clothing": "2e8b1b95-3876-45c3-ba49-95ceb15670d6",
  "Men's Clothing": "592bc05c-6b1b-40d8-bac1-e50c359e0915",
  "Clothing": "6639a424-786e-414a-abc5-c71679ccab88",
  "Shoe Store": "ba77772f-c67a-4176-a4f0-bdb90f512c87",
  "Home Goods": "16f8477b-6bb4-4769-bb37-401c7e8f0a11",
  "Books": "86378af5-49d4-431e-9c00-d818e737a71f",
  "Multi Category Store": "f0b63a05-36f6-4e8a-9f79-8c234d2e856d",
  "Gifts": "c3a5fc79-4c4d-449a-89d2-60d8a543b8c3",
  "Vintage / Thrift": "11f8ccaa-e272-46cc-8da2-0ac4b04fd215",
  "Other": "be731f05-dde4-4cfe-9e3a-eefadf9309fb",
  "Outdoor Clothing": "2e668152-5785-461f-8787-5e64394cffc6"
};

const posOptions: Record<string, string> = {
  Clover: "d893be7c-e180-4e46-8a62-1e62d5af91e6",
  Heartland: "f43b00de-7716-4b76-a4f7-298ae8a3409d",
  Lightspeed: "0a7d7273-badb-402c-8b6b-17c1ca7bd3f6",
  Quickbooks: "9e8d8e54-099d-406b-9cee-fc163d0c53c2",
  RetailPro: "c2593019-92b7-453f-a29e-b73458282138",
  RICS: "a4cb31a9-70ee-4251-92b3-ecd69739b593",
  Shopify: "2326b917-b1d8-45d5-8e1d-bb9eb9a63b8b",
  Square: "4f86ebd5-f2f0-4acb-9dc9-f25181d71b96",
  Squarespace: "b38f3140-b9a2-461b-bf74-a0adb3b7ffb7",
  Other: "f16c4f25-8a9d-4135-8a72-8f2d39276efe"
};

const employeeCountOptions: Record<string, string> = {
  "0-25": "b5ec9b8d-c89b-4df1-8704-568f08420222",
  "26-100": "90e1d7d0-9250-45a4-ba21-6d08f9c148d9",
  "101+": "a99dee0c-edcd-45ec-95f0-36af1329c741"
};


const ContactUsPage: React.FC = () => {
  const [formData, setFormData] = useState<{
  name: string;
  email: string;
  company: string;
  message: string;
  stateRegion: string;
  referralSource: string[]; // ← Make sure this is explicitly string[]
  posSystem: string;
  city: string;
  phone: string;
  contactTitle: string;
  jobTitle: string;
  website: string;
  storeType: string;
  employeeCount: string;
}>({
  name: "",
  email: "",
  company: "",
  message: "",
  stateRegion: "",
  referralSource: [], // ← initial value is an empty string array
  posSystem: "",
  city: "",
  phone: "",
  contactTitle: "",
  jobTitle: "",
  website: "",
  storeType: "",
  employeeCount: "",
});


  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | { name?: string; value: unknown }>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name!]: value }));
  };

  const formatPhoneNumberForClickUp = (phone: string): string => {
  // Strip all non-digit characters
  const digitsOnly = phone.replace(/\D/g, "");

  // Ensure it's at least 10 digits long (U.S. format)
  if (digitsOnly.length === 10) {
    return `+1 ${digitsOnly.slice(0, 3)} ${digitsOnly.slice(3, 6)} ${digitsOnly.slice(6)}`;
  } else if (digitsOnly.length === 11 && digitsOnly.startsWith("1")) {
    return `+1 ${digitsOnly.slice(1, 4)} ${digitsOnly.slice(4, 7)} ${digitsOnly.slice(7)}`;
  }

  // Fallback: Return original string (ClickUp may reject if invalid)
  return phone;
};

  const handleCheckboxChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      referralSource: checked
        ? [...prev.referralSource, value]
        : prev.referralSource.filter((source) => source !== value),
    }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);

    const clickupApiToken = "pk_49808893_DZF8VDBH54SA0AIQLFB13FW9XOF51MTO";
    const clickupListId = "901104335763";

    const customFields = [
      { id: "047f0132-c6e5-4912-9003-5cc670214f58", value: formData.city },
      { id: "04b12bcf-1821-4163-ba0a-340c98b48782", value: storeTypeOptions[formData.storeType], },
      { id: "07e8ada4-0cc9-43b0-adbf-5837b2ebbc55", value: stateOptions[formData.stateRegion] },
      { id: "0ad30ad5-a0ca-48c9-8b90-6022b9f1f7e0", value: formData.email },
      { id: "17aa09f5-8603-48ad-bed5-5715004becec", value: formatPhoneNumberForClickUp(formData.phone) },
      { id: "215fbb9f-b901-4468-8771-395dc4422bd3", value: formData.website },
      { id: "65a1c8a5-8411-4c48-b0bb-85dc32ed16b7", value: formData.name },
      { id: "9e009c08-1828-40e6-908d-be7ffc47aa29", value: employeeCountOptions[formData.employeeCount], },
      { id: "c6b874d4-3b74-4997-8fc1-cdfa6ab048ec", value: posOptions[formData.posSystem], },
      { id: "d60922e9-53df-4eef-a744-dd401e78871a", value: formData.contactTitle },
      { id: "fde7628a-8859-4fc2-bd98-73b717358970", value: formData.jobTitle },
    ];

    console.log(customFields)

    const taskData = {
      name: `${formData.company}`,
      description: `**Name**: ${formData.name}\n**Email**: ${formData.email}\n**Company**: ${formData.company}\n**Message**: ${formData.message}\n**Referral Source**: ${formData.referralSource.join(", ")}`,
      contact: formData.email,
      custom_fields: customFields,
    };

    try {
      const response = await fetch(`https://api.clickup.com/api/v2/list/${clickupListId}/task`, {
        method: "POST",
        headers: {
          Authorization: clickupApiToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(taskData),
      });

      if (response.ok) {
        alert("Your message has been submitted successfully!");
      } else {
        alert("There was an error submitting your message. Please try again.");
      }
    } catch (error) {
      alert("There was an error submitting your message. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 4 }}>
            <Typography variant="h4" gutterBottom>
              Learn More
            </Typography>
            <form onSubmit={handleSubmit}>
              {[
                { label: "Name", name: "name" },
                { label: "Email", name: "email", type: "email" },
                { label: "Company", name: "company" },
                { label: "Phone", name: "phone" },
              ].map(({ label, name, type }) => (
                <TextField key={name} fullWidth label={label} name={name} type={type || "text"} value={(formData as any)[name]} onChange={handleChange} margin="normal" required={name !== "jobTitle" && name !== "contactTitle" && name !== "phone"} />
              ))}

              <FormControl fullWidth margin="normal" required>
                <InputLabel>State</InputLabel>
                <Select
                  name="stateRegion"
                  value={formData.stateRegion}
                  onChange={handleChange as any}
                >
                  {[
                    "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA",
                    "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD",
                    "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
                    "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC",
                    "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"
                  ].map((abbr) => (
                    <MenuItem key={abbr} value={abbr}>{abbr}</MenuItem>
                  ))}
                </Select>
              </FormControl>

              {[
                { label: "City", name: "city" },
                { label: "Job Title", name: "jobTitle" },
                { label: "Website", name: "website" },
              ].map(({ label, name }) => (
                <TextField key={name} fullWidth label={label} name={name} type={"text"} value={(formData as any)[name]} onChange={handleChange} margin="normal" required={name !== "jobTitle" && name !== "contactTitle"} />
              ))}

              <Typography variant="h6" sx={{ mt: 2 }}>How did you hear about us?</Typography>
              {["Another Brand", "Boutique Hub", "Facebook", "Google", "Instagram", "Linkedin", "Management One", "Podcast", "Shoe Dogs United FB", "Tradeshow", "WhizBang", "Affiliate"].map((option) => (
                <FormControlLabel key={option} control={<Checkbox value={option} onChange={handleCheckboxChange} checked={formData.referralSource.includes(option)} />} label={option} />
              ))}

              {[{
                label: "POS System", name: "posSystem",
                options: ["Clover", "Heartland", "RetailPro", "Other", "Shopify", "Square", "RICS", "Lightspeed", "Quickbooks"]
              }, {
                label: "Store Type", name: "storeType",
                options: ["Kids", "Women's Clothing", "Men's Clothing", "Clothing", "Shoe Store", "Home Goods", "Books", "Multi Category Store", "Gifts", "Vintage / Thrift", "Other", "Outdoor Clothing"]
              }, {
                label: "Employee Count", name: "employeeCount",
                options: ["0-25", "26-100", "101+"]
              }].map(({ label, name, options }) => (
                <FormControl fullWidth margin="normal" key={name}>
                  <InputLabel>{label}</InputLabel>
                  <Select name={name} value={(formData as any)[name]} onChange={handleChange as any}>
                    {options.map((option) => (
                      <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ))}

              <TextField fullWidth label="Message" name="message" value={formData.message} onChange={handleChange} margin="normal" multiline rows={4} required />
              <Button type="submit" variant="contained" color="primary" disabled={isSubmitting} sx={{ mt: 2 }}>
                {isSubmitting ? "Sending..." : "Submit"}
              </Button>
            </form>
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card elevation={3} sx={{ p: 4, backgroundColor: "#f9f9f9" }}>
            <CardContent>
              <Box component="img" src={contactUsImage} alt="Contact" mb={4} sx={{ width: "100%", height: "auto" }} />
              <Typography variant="h4" gutterBottom>
                Join Our Community
              </Typography>
              <Typography variant="body1" gutterBottom>
                In 20 minutes you'll:
              </Typography>
              <ul>
                <li>Sign up with a new ShareStock account</li>
                <li>Connect with your Shopify store</li>
                <li>Start a new sales channel for your business</li>
                <li>Gain access to the power of shared inventory!</li>
              </ul>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ContactUsPage;
